
/** 
 * Validate API request/response input against expected input
 * @param {Object} userInput - The user input object to validate
 * @param {Object} expectedInput - The expected input object with potential regex patterns
 * @returns {boolean} True if input matches expected input, false otherwise
 */
function validateApiInput(userInput, expectedInput) {

  // Normalize user input keys to match expected input keys (case-insensitive)
  const normalizedUserInput = Object.keys(userInput).reduce((acc, key) => {
    const matchingKey = Object.keys(expectedInput).find(
      (expectedKey) => expectedKey.toLowerCase() === key.toLowerCase()
    ) || key; // Use found key or keep original

    acc[matchingKey] = userInput[key];
    return acc;
  }, {});

  function normalizeValue(value) {
    if (typeof value === "string" && !isNaN(value.trim())) {
      return Number(value); // Convert numeric string to number
    }
    return value;
  }

  function validateValue(userValue, expectedValue) {
    if ((userValue === '' || userValue === undefined) && 
        (expectedValue === '' || expectedValue === undefined)) {
      return true;
    }


    // Skip normalization for regex-based checks
    if (typeof expectedValue === "string" && expectedValue.startsWith("^")) {
      try {
        const regex = new RegExp(expectedValue.trim());
        const isMatch = regex.test(userValue);
        return isMatch;
      } catch (error) {
        return false;
      }
    }

    // Normalize non-regex values
    userValue = normalizeValue(userValue);
    expectedValue = normalizeValue(expectedValue);

    if (userValue === expectedValue) {
      return true;
    } else {
      return false;
    }
  }

  function validateArrayOfPairs(userArray, expectedArray, keyName) {
    // Filter out empty key-value pairs before validating
    const filteredUserArray = userArray ? userArray.filter(pair => pair.key !== '' || pair.value !== '') : [];
    const filteredExpectedArray = expectedArray || [];

    const isUserArrayEmpty = filteredUserArray.length === 0;
    const isExpectedArrayEmpty = filteredExpectedArray.length === 0;

    if (isUserArrayEmpty && isExpectedArrayEmpty) {
      return true;
    }

    if (filteredUserArray.length < filteredExpectedArray.length) {
      return false;
    }

    return filteredExpectedArray.every(expectedPair =>
      filteredUserArray.some(userPair => {
        const keyMatch = validateValue(userPair.key, expectedPair.key);
        const valueMatch = validateValue(userPair.value, expectedPair.value);
        if (!keyMatch || !valueMatch) {
        }
        return keyMatch && valueMatch;
      })
    );
  }

  for (const key in expectedInput) {
    if (!(key in normalizedUserInput)) {
      if (
        typeof expectedInput[key] === "object" &&
        Object.keys(expectedInput[key]).length === 0
      ) {
        continue;
      }
      return false;
    }

    switch (key.toLowerCase()) {
      case 'headers':
      case 'params':
      case 'cookies':
        if (!validateArrayOfPairs(normalizedUserInput[key], expectedInput[key], key)) {
          return false;
        }
        break;
      case 'response':
        if (!validateApiInput(normalizedUserInput[key], expectedInput[key])) {
          return false;
        }
        break;
      default:
        if (!validateValue(normalizedUserInput[key], expectedInput[key])) {
          return false;
        }
    }
  }

  return true;
}

module.exports = validateApiInput;